// Welcome pages shown once, right after registering, before the confirmation page.
// A race shows one only when its Stripe product metadata has `referralCard` set to one of these keys
// (e.g. referralCard = 60northrun). Add an entry here to give another challenge its own welcome:
// the layout, invite box and checklist are shared; the entry sets the words, logo, coupon, rewards image and decoration.
export const WELCOME_THEMES = {
  "60northrun": {
    key: "60northrun",
    raceLabel: "60° North Run",
    identity: "Winter Warrior",
    logoUrl: "/img/momentum-logos/01-jan.webp",
    accent: "#0a6cc4",
    // Background decoration on the welcome page: "snow", or leave it out for none. See WelcomeDecor.jsx.
    decoration: "snow",
    // Added to every invite link so the friend's $5 discount is applied at checkout.
    // It must be listed in Firestore options/validPromoCodes to be applied.
    promoCode: "MCC60NR24YZ7",
    inviteTitle: "Refer your friends. You both get rewarded.",
    inviteText: "Your friends get $5 off, and you earn amazing gifts.",
    inviteGoal: "Just one friend gets you the Winter Warrior stickers.",
    rewardsImage: "/img/rewards/MCC-Referal-rewards2.jpg",
    shareSubject: "Join me in the 60° North Run",
    shareText: (withReferral) =>
      withReferral
        ? "I just signed up for the 60° North Run this January. Want to start the year moving with me? Join me and save $5:"
        : "I just signed up for the 60° North Run this January. Want to start the year moving with me? Join me:",
  },
};

// Returns the welcome named in the race's metadata, or null when the race has none.
export function getWelcomeTheme(raceData) {
  const key = `${raceData?.metadata?.referralCard ?? ""}`.trim();
  return (key && WELCOME_THEMES[key]) || null;
}
